import React from 'react';

const ErrorPage = (): JSX.Element => <div>An unexpected error has occurred.</div>;

export default ErrorPage;
